// extracted by mini-css-extract-plugin
module.exports = {"promoInfo":"_32bbee5fda--promoInfo--Zs3Uu","promoInfo-text":"_32bbee5fda--promoInfo-text--Zd6UX","promoSaleInfo":"_32bbee5fda--promoSaleInfo--P3eS4"};